import React, { PropTypes } from 'react';
import SelectField from 'material-ui/SelectField';
import {MenuItem} from 'material-ui/Menu';
import Avatar from 'material-ui/Avatar';

class TwoColumnsContentParticipantCell extends React.Component {
  static propTypes = {
    participants: PropTypes.array.isRequired,
    cell: PropTypes.object,
    onUpdate: PropTypes.func.isRequired
  };

  state = {
    value: 1
  };

  handleChange = (event, index, id) => {
    let {
      onUpdate,
      participants
    } = this.props;

    onUpdate(id !== 'free'
      ? participants.find(participant => participant.id === id)
      : null
    );
  };

  render() {
    let {
      cell,
      participants
    } = this.props;

    return (
      <div style={{display: 'flex', alignItems: 'center'}}>
        <Avatar src={cell.avatar}/>
        <SelectField value={cell.record_id} onChange={this.handleChange}>
          <MenuItem value={'free'} primaryText={'Free agent'} />
          {participants.map(
            participant => (
              <MenuItem key={participant.id} value={participant.id} primaryText={participant.name} />
            )
          )}

        </SelectField>
      </div>
    );
  }
}

export default TwoColumnsContentParticipantCell;



// WEBPACK FOOTER //
// ./src/components/ClubCMS/Content/TwoColumnContent/TwoColumnsContentParticipantCell/TwoColumnsContentParticipantCell.js